export const TAB_TYPE = {
  SPOT: 'spot', // スポット検索
  ADDRESS: 'address' // 住所検索
};
export const KIND = {
  AUTOCOMPLETE: 'autocomplete', // オートコンプリート検索
  LIST: 'list' // リスト検索
};

/**
 * POI検索ログを送信するクラス
 */
class PoiSearchLog {
  /**
   * コンストラクタ
   */
  constructor(merengue, siteId, lang) {
    this.merengue = merengue;
    this.siteId = siteId;
    this.lang = lang;
  }

  /**
   * オートコンプリート検索時のログ送信
   * @param {string} word 検索ワード
   * @param {Array} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   */
  // sendSearchAutocompleteTiming = (word, poiList, mochaParam, moveType) => {
  //   this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.SPOT, KIND.AUTOCOMPLETE, moveType, null));
  // };

  /**
   * オートコンプリート未選択時のログ送信
   * @param {string} word 検索ワード
   * @param {Array} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   */
  sendUnselectAutocompleteTiming = (word, poiList, mochaParam, moveType) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.SPOT, KIND.AUTOCOMPLETE, moveType, null));
  };

  /**
   * 住所検索時のログ送信
   * @param {*} word 検索ワード
   * @param {*} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   */
  sendSearchAddressTiming = (word, poiList, mochaParam, moveType) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.ADDRESS, KIND.LIST, moveType, null));
  };

  /**
   * スポット検索時のログ送信
   * @param {*} word 検索ワード
   * @param {*} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   */
  sendSearchSpotTiming = (word, poiList, mochaParam, moveType) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.SPOT, KIND.LIST, moveType, null));
  };

  /**
   * オートコンプリート選択時のログ送信
   * @param {*} word 検索ワード
   * @param {*} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   * @param {*} selectPoi 選択したPOI
   */
  sendSelectAutocompleteTiming = (word, poiList, mochaParam, moveType, selectPoi) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.SPOT, KIND.AUTOCOMPLETE, moveType, selectPoi));
  };

  /**
   * 住所選択時のログ送信
   * @param {*} word 検索ワード
   * @param {*} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   * @param {*} selectPoi 選択したPOI
   */
  sendSelectAddressTiming = (word, poiList, mochaParam, moveType, selectPoi) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.ADDRESS, KIND.LIST, moveType, selectPoi));
  };

  /**
   * スポット選択時のログ送信
   * @param {*} word 検索ワード
   * @param {*} poiList 検索結果POIリスト
   * @param {*} mochaParam mochaへのリクエストパラメータ
   * @param {*} moveType 移動手段
   * @param {*} selectPoi 選択したPOI
   */
  sendSelectSpotTiming = (word, poiList, mochaParam, moveType, selectPoi) => {
    this._sendLog(this._createParam(word, poiList, mochaParam, TAB_TYPE.SPOT, KIND.LIST, moveType, selectPoi));
  };


  /**
   * POI検索ログのパラメータを作成します。
   * @param {{}} param パラメータ
   */
  _createParam = (word, poiList, mochaParam, tab, kind, moveType, selectPoi) => {
    const rank = selectPoi ? poiList.findIndex((poi) => (poi.code ?? poi.id) === (selectPoi.code ?? selectPoi.id)) + 1 : 0;
    const param = {
      word: word,
      rank: rank,
      tab: tab,
      kind: kind,
      poi: {
        candidates: poiList.filter((poi) => poi.code || poi.id).map((poi) => ({ id: poi.code ?? poi.id, name: poi.name.ja ?? poi.name })).slice(0, 5)
      },
      moveType: moveType,
      mocha: mochaParam
    };
    if (selectPoi)  {
      param.poi.selected = { id: selectPoi.code ?? selectPoi.id, name: selectPoi.name.ja ?? selectPoi.name };
    }
    return param;
  };

  /**
   * POI検索ログを送信します。
   * @param {{}} param パラメータ
   */
  _sendLog = (param) => {
    this.merengue.sendPoiLog(this.siteId, this.lang, param);
  };
}
export default PoiSearchLog;
